var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBasicissuanceActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    strokeWidth: 1.5,
    fill: "none",
    strokeDasharray: "0,0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 3.1c0-1.5-.64-2.1-2.23-2.1h-4.04c-1.59 0-2.23.6-2.23 2.1v6.8c0 1.5.64 2.1 2.23 2.1h4.04c1.59 0 2.23-.6 2.23-2.1V3.1z",
    stroke: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 17.1c0-1.5-.64-2.1-2.23-2.1h-4.04c-1.59 0-2.23.6-2.23 2.1v1.8c0 1.5.64 2.1 2.23 2.1h4.04c1.59 0 2.23-.6 2.23-2.1v-1.8z",
    stroke: "#00E1D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 18.9c0 1.5-.64 2.1-2.23 2.1H3.23C1.64 21 1 20.4 1 18.9v-6.8c0-1.5.64-2.1 2.23-2.1h4.04c1.59 0 2.23.6 2.23 2.1v6.8z",
    stroke: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 4.9C9.5 6.4 8.86 7 7.27 7H3.23C1.64 7 1 6.4 1 4.9V3.1C1 1.6 1.64 1 3.23 1h4.04c1.59 0 2.23.6 2.23 2.1v1.8z",
    stroke: "#00E1D4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBasicissuanceActive);
export default __webpack_public_path__ + "static/media/icon-basicissuance-active.c76365a43b3eeb11d99eb52b5b46f8df.svg";
export { ForwardRef as ReactComponent };